import { IJobAppTerm } from "../schemas/user.schema";

export const default_JobAppTerm: IJobAppTerm = {
  _id: "",
  title: "Default Term",
  xCompleted: true,
};
